/* Caption geometry changes with layout, not with unrelated text mutations.
   Read every dirty caption first, then commit only values that changed. */
(() => {
  const selector = '[data-ak-caption-collection]';
  const captions = new Map();
  const dirty = new Set();
  let frame = 0;
  function queue(caption) {
    if (caption) dirty.add(caption);
    if (dirty.size && !frame) frame = requestAnimationFrame(sync);
  }
  function sync() {
    frame = 0;
    const writes = [];
    dirty.forEach(caption => {
      if (!caption.isConnected) {
        sizes.unobserve(caption); captions.delete(caption); return;
      }
      if (!caption.getBoundingClientRect().width) return;
      const box = getComputedStyle(caption);
      writes.push([caption,
        `${Math.max(0,parseFloat(box.paddingBottom)-parseFloat(box.borderTopWidth))}px`,
        box.paddingLeft]);
    });
    dirty.clear();
    writes.forEach(([caption,top,left]) => {
      if (caption.style.getPropertyValue('--ak-caption-label-top') !== top)
        caption.style.setProperty('--ak-caption-label-top',top);
      if (caption.style.getPropertyValue('--ak-caption-label-left') !== left)
        caption.style.setProperty('--ak-caption-label-left',left);
    });
  }
  const sizes = new ResizeObserver(entries => entries.forEach(entry => queue(entry.target)));
  function collect(root) {
    if (!root || root.nodeType !== 1) return;
    const labels = root.matches(selector) ? [root] : root.querySelectorAll(selector);
    labels.forEach(label => {
      const caption = label.closest('[data-ak-price-caption]');
      if (!caption || !caption.querySelector('[data-ak-caption-price]')) return;
      if (!captions.has(caption)) { captions.set(caption,true); sizes.observe(caption); }
      queue(caption);
    });
  }
  function refresh() { captions.forEach((_,caption) => queue(caption)); }
  new MutationObserver(records => {
    records.forEach(record => record.addedNodes.forEach(collect));
    captions.forEach((_,caption) => {
      if (!caption.isConnected) { sizes.unobserve(caption); captions.delete(caption); dirty.delete(caption); }
    });
  }).observe(document.documentElement,{childList:true,subtree:true});
  window.addEventListener('resize',refresh,{passive:true});
  window.addEventListener('ak:colour-theme-change',refresh);
  document.fonts?.ready.then(refresh);
  collect(document.documentElement);
})();
